import * as AT from './actionTypes'

export type RequestHistoryActionType = {
  payload: { readonly year: number }
  type: typeof AT.REQUEST_HISTORY
}

const requestHistory = (year: number): RequestHistoryActionType => ({
  payload: { year },
  type: AT.REQUEST_HISTORY
})

export default { requestHistory }
